var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 4.08398H9.91537V5.25065H4.08203V4.08398ZM4.08203 6.41732H8.16536V7.58398H4.08203V6.41732Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.668 1.16602H2.33464C1.69122 1.16602 1.16797 1.68927 1.16797 2.33268V12.8327L4.27889 10.4993H11.668C12.3114 10.4993 12.8346 9.9761 12.8346 9.33268V2.33268C12.8346 1.68927 12.3114 1.16602 11.668 1.16602ZM11.668 9.33268H3.89039L2.33464 10.4993V2.33268H11.668V9.33268Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteComment);
export default __webpack_public_path__ + "static/media/vote-comment.b598a79e32350701f98cb9a9ead387e2.svg";
export { ForwardRef as ReactComponent };